import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { borderRadius, padding, fontSize, fontWeight, margin, gridGap, layout } from 'styled-system';
import { getBackgroundColor, themeGet, getTextContrast, theme, getTextColor } from '@magalu/stereo-ui-styles';
const DEFAULT_BG_COLOR = 'primary';
const SCALES_VARIATIONS = {
  light: theme.palette.text.white,
  dark: theme.palette.text.base
};
const displayTransition = `
  -webkit-transition: all 500ms ease;
  transition: all 500ms ease;
`;
const displayBase = `
  ${displayTransition}
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
const displaySize = {
  xsmall: '18px',
  small: '28px',
  medium: '38px'
};

const displayColorLayout = ({
  props,
  variation,
  checked = false
}) => {
  const {
    bg,
    type,
    scales = SCALES_VARIATIONS
  } = props;
  const variations = {
    colorfulTransition: css`
      ${displayTransition}
      background-color: ${getBackgroundColor(bg || DEFAULT_BG_COLOR)(props)};
      color: ${getTextContrast(bg || DEFAULT_BG_COLOR, scales)(props)};
      > svg {
        ${displayTransition}
        fill: ${getTextContrast(bg || DEFAULT_BG_COLOR, scales)(props)};
      }
    `,
    colorful: css`
      ${displayTransition}
      background-color: ${getBackgroundColor(bg || DEFAULT_BG_COLOR)(props)};
      color: ${getTextContrast(bg || DEFAULT_BG_COLOR, scales)(props)};
      > svg {
        ${displayTransition}
        fill: ${getTextContrast(bg || DEFAULT_BG_COLOR, scales)(props)};
      }
    `,
    default: css`
      background-color: ${getBackgroundColor('white')(props)};
      color: ${getTextContrast('white', scales)(props)};
    `
  };
  const variationType = bg && (checked || !type.includes('radio', 'checkbox')) ? 'colorful' : 'default';
  return variations[variation || variationType];
};

export const Container = styled.div`
  ${margin}
  ${layout}
  text-decoration: none;
`;
export const Label = styled.label`
  display: flex;
  justify-content: ${({
  justify
}) => justify};
  align-items: center;
  border: ${({
  hasBorder
}) => hasBorder ? '1px solid' : 'none'};
  scroll-snap-align: center;
  border-radius: ${props => themeGet('space.4')(props)}px;

  min-width: ${({
  minWidth
}) => minWidth};
  height: ${props => displaySize[props == null ? void 0 : props.size]};

  ${props => displayColorLayout({
  props
})};

  ${({
  autoSize
}) => autoSize ? css`
          justify-content: space-around;
          width: auto;
          min-width: auto;
          height: auto;
          padding: ${themeGet('space.2')}px ${themeGet('space.2')}px;
        ` : css`
          max-width: ${({
  maxWidth
}) => maxWidth};
        `}

  ${displayBase}
  ${displayTransition}
  ${borderRadius}
  ${padding}
  ${fontSize}
  ${fontWeight}
  ${gridGap}
`;
export const Text = styled.p`
  max-width: ${({
  textMaxWidth
}) => textMaxWidth};
  font-size: inherit;
  font-weight: inherit;
  line-height: ${props => themeGet('lineHeights.standard')(props)}px;
  font-stretch: normal;
  letter-spacing: normal;

  ${_ref => {
  let {
    color
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["color"]);

  return color && css`
      color: ${getTextColor(color)(props)};
    `;
}}

  ${({
  autoSize
}) => autoSize && css`
      max-width: 100%;
    `};
`;
export const Input = styled.input`
  ${displayBase}
  display: none;

  &:checked + ${Label} {
    ${props => displayColorLayout({
  props,
  variation: 'colorfulTransition',
  checked: true
})};
  }
`;